import { render, staticRenderFns } from "./my-prize.vue?vue&type=template&id=3a54ef90&scoped=true&"
import script from "./my-prize.vue?vue&type=script&lang=js&"
export * from "./my-prize.vue?vue&type=script&lang=js&"
import style0 from "./my-prize.vue?vue&type=style&index=0&id=3a54ef90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a54ef90",
  null
  
)

export default component.exports